<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Respuestas</h4>
    <hr />

    <DataTable
      :data="respuestas"
      :columns="columnas"
      idField="idRespuesta"
      mensajeVacio="No hay registros de respuestas."
      :mostrarVer="false"
      @refresh="getDataPaginaTodos"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idRespuesta)"
      @delete="row => deleteRespuesta(row.idRespuesta)"
    />

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">{{ titulo }}</h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Descripción</label></div>
                <div class="col-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="datoRespuesta.descripcion"
                    style="text-transform:uppercase"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarRespuesta"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarRespuesta"
              v-if="btnEditar"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  components: { Layout, Footer, DataTable },
  data() {
    return {
      respuestas:    [],
      datoRespuesta: {},
      titulo:        "",
      btnCrear:      false,
      btnEditar:     false,
      modalWindow:   true,
      idEmpresa:     0,
      idPerfil:      0,
    };
  },
  computed: {
    columnas() {
      const cols = [];
      if (this.idPerfil == 1) cols.push({ label: "Empresa", field: "empresaNombreCorto" });
      cols.push(
        { label: 'Descripción', field: 'descripcion' },
      );
      return cols;
    },
  },
  mounted() {
    this.idEmpresa = window.sessionStorage.getItem("idEmpresa");
    this.idPerfil  = Number(window.sessionStorage.getItem("idPerfil"));	
    this.getDataPaginaTodos();
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  },
  methods: {
    getDataPaginaTodos() {
      api.get(`/vwrespuestas/idempresa/${this.idEmpresa}`)
        .then(r => { this.respuestas = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar respuestas:", e));
    },
    validarForm() {
      return validarForm(this.datoRespuesta, ["descripcion"], ["descripcion"]);
    },
    async guardarRespuesta() {
      if (this.validarForm() !== 1) return;
      try {
        this.datoRespuesta.idEmpresa = this.idEmpresa;
        await api.post("/respuestas", this.datoRespuesta);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Respuesta creada exitosamente." });
        this.getDataPaginaTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },
    async actualizarRespuesta() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/respuestas", this.datoRespuesta);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Respuesta actualizada exitosamente." });
        this.getDataPaginaTodos();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },
    async deleteRespuesta(idRespuesta) {
      const confirm = await Swal.fire({
        title: "¿Eliminar respuesta?",
        text: "Esta acción no se puede deshacer.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/respuestas/" + idRespuesta);
        this.getDataPaginaTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },
    abrirModalCrear() {
      this.modalWindow   = true;
      this.datoRespuesta = {};
      this.titulo        = "Crear respuesta estándar";
      this.btnCrear      = true;
      this.btnEditar     = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },
    async abrirModalEditar(idRespuesta) {
      this.modalWindow = true;
      this.titulo      = "Editar respuesta estándar";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp         = await api.get("/vwrespuestas/" + idRespuesta);
        this.datoRespuesta = resp.data;
      } catch (e) {
        console.error("Error al cargar respuesta:", e);
        return;
      }
      $("#ventanaModal").modal("show");
    },
  },
};
</script>